import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import CallToActionImage from '@bd/bdui-calltoactionimage';
import withData from '@bd/bdcore-data';
import { grid, typography, colors } from '../styles';

const BannerStyles = css`
  padding: 45px 0;
  background-color: ${colors.color1};
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .CTABanner_title {
    color: #FFFFFF;
    font-family: ${typography.Serif};
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 2px;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 48px;
    }
  }
  .CTABanner_preTitle {
    font-weight: 300;
    display: block;
    @media (min-width: 992px) {
      display: inline-block;
      font-weight: 700;
    }
  }
  .CTABanner_subTitle {
    font-family: ${typography.Serif};
    font-size: 24px;
    font-weight: 300;
    color: #FFFFFF;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 28px;
    }
  }
`;

const CTAstyles = css`
  ${grid.makeCol(12)}
  z-index: 0;
  margin: 0 0 30px 0;
  &:first-child {
    margin-top: 30px;
  }
  @media (min-width: 992px) {
    ${grid.makeCol(4)}
    margin: 60px 0;
    &:first-child {
      margin-top: 60px;
    }
  }
  .CTAButton_wrapper {

    a {
      display: block;
    }
  }
  .CTAButton_inner {
    height: 100%;
    position: relative;
    background-size: cover;
    padding-top: 56.25%;
    @media (min-width: 992px) {
      padding: 0 30px;
      padding-top: 56.25%;
    }
  }
  .CTAButton_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${colors.color2};
    padding: 10px 20px;
    text-align: left;
    text-transform:capitalize;
  }
  .CTAButton_preTitle {
    font-size: 15px;
    line-height: 1;
    color: #FFFFFF;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }
  .CTAButton_title {
    color: #FFFFFF;
    font-size : 20px;
    font-weight : 700;
    line-height : 1;
    position: relative;
  }
  .CTAButton_body {
    display: none;
    @media (min-width: 992px) {
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 800;
      line-height: 19px;
    }
  }
  .CTAButton_buttonContainer {
    position: absolute;
    right: 20px;
    bottom: 32px;
    @media (min-width: 992px) {
      right: 60px;
      bottom: 25px;
    }
  }
`;

function CtaButtons({ widget }) {
  return (
    <div className={BannerStyles}>
      <div className="container">
        <h3 className="CTABanner_title">
          <span className="CTABanner_preTitle">Build Your&nbsp;</span>
          Dream Home Today!
        </h3>
        <h4 className="CTABanner_subTitle">
          Let us make it a reality!
        </h4>
        <div className="row">
          {widget.cta_button.map(cta => (
            <CallToActionImage
              className={CTAstyles}
              key={cta.title}
              backgroundImage={get(cta, 'image.contentUrl')}
              title={cta.title}
              route={cta.route}
              path={cta.external_url}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
CtaButtons.propTypes = {
  widget: PropTypes.object.isRequired,
};
export default withData({
  widget: 'ctabanner',
})(CtaButtons);



// WEBPACK FOOTER //
// ./src/components/CTABanner.js